import classNames from 'classnames';
import React, { useMemo } from 'react';
import { DropdownSubMenuItem } from '../../molecules/DropdownSubMenuItem';
import { specialist_mode, role_client } from '../../templates/Header/menu_data/data';
import { AuthContainer } from '../Auth/AuthContainer';
import * as styles from './menu.module.sass';
import { useSelector } from 'react-redux';
import { getCurrentUserSelector } from '../../../store/auth/selector';
import { useTranslation } from '../../../i18n/use-translation';
import { viewportWidthSelector } from '../../../store/app/selector';
import { useConfig } from '../../../config/context';

export const DropdownSubMenu = () => {
  const user = useSelector(getCurrentUserSelector);
  const { t, locale } = useTranslation();
  const config = useConfig()
  const mobileView = useSelector(viewportWidthSelector)

  

  const CompanyMenuItem = useMemo(() => {
    // if (app.user.parent) {
    // @ts-ignore
    if (user?.company) {
      return (
        <div className={styles.cabinet_company}>
          <DropdownSubMenuItem
            route={'cabinet/company/profile'}
            title={'profile_my_company'}
            icon={'bussiness'}
            className={classNames(styles.cabinet_item)}
          />
        </div>
      );
    } else if (user?.roles.find((role: string) => role === 'ROLE_EXPERT')) {
      return (
        <div className={styles.cabinet_company}>
          {/* Профіль слініки Реєстратор  */}
          <DropdownSubMenuItem
            route={'cabinet/schedule'}
            title={'profile_my_company'}
            icon={'bussiness'}
            className={classNames(styles.cabinet_item)}
          />
        </div>
      );
    }
    return (
      <div className={styles.cabinet_company}>
        {/* v1.2 Реєстрація клініки  */}
        <DropdownSubMenuItem
          route={'cabinet/register-company'}
          title={'medical_institution_registration'}
          icon={'bussiness'}
          className={classNames(styles.cabinet_item)}
        />
      </div>
    );
    // }
  }, [user?.id]);



  const submenu = useMemo(() => {
    if (user?.specialist_mode) {
      return specialist_mode.map((item, key) => {
        return <DropdownSubMenuItem key={key} route={item.route} title={item.title} icon={item.icon} />;
      });
    } else if (user?.roles.find((role: string) => role === 'ROLE_CLIENT') && !user?.specialist_mode) {
      return role_client.map((item, key) => {
        return <DropdownSubMenuItem key={key} route={item.route} title={item.title} icon={item.icon} />;
      });
    }
  }, [user?.id]);
  

  if (user) {
    return (
      <div className={styles.dropdown}>
        <a className="cabinet-preview__element" href={`/${locale}/cabinet/settings`} data-cy="element-profile">
          <img
            className={styles.cabinet_img}
            src={user?.avatar || '/public-assets/img/shared/no_avatar.svg'}
            alt="avatar"
          />
          {mobileView > config.MEDIAQUERY.MOBILE && <span>{t('subtitle_login')}</span>}
        </a>
        <div className={styles.dropdown_body}>
          <div className={styles.cabinet_head}>
            <div className={styles.cabinet_name}>{user?.fullName}</div>
            <div className={styles.cabinet_mail}>{t('menu_phone')} : {user?.phone}</div>
          </div>
          <div className={styles.cabinet_company}>{CompanyMenuItem}</div>

          <div className={styles.cabinet_nav}>
            {submenu}
            {user?.roles.find((role: string) => role === 'ROLE_EHEALTH_MEMBER') && (
              <DropdownSubMenuItem route={'e-health/app'} title={'E-Health'} icon={'local_hospital'} />
            )}

            <DropdownSubMenuItem route={'cabinet/settings'} title={'profile_main_settings'} icon={'settings'} />
          </div>
          <div className={styles.cabinet_footer}>
            <DropdownSubMenuItem
              route={'logout'}
              title={'profile_logout'}
              icon={'backspace'}
              className={classNames(styles.cabinet_item, styles.logout)}
            />
          </div>
        </div>
      </div>
    );
  }
  return mobileView > config.MEDIAQUERY.LAPTOP && <AuthContainer />;
};
